module.exports = __webpack_public_path__ + "static/media/15-iveco.c995769d.jpg";